export const viewTitle = "Список пользователей";
export const viewUniqKey = "users-list";
